module.exports = __webpack_public_path__ + "static/media/cable_car.cba6e01e.svg";